import { createFileRoute } from '@tanstack/react-router';

import { Visions } from '@/view/pages/Visions';

export const Route = createFileRoute('/_protected/$programId/visoes')({
  component: Visions,
  context: (context): { title: string } => ({
    ...context,
    title: 'Visões',
  }),
});
